import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, ElementRef, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { API_BASE_URL } from '../../environments/environment';
import { MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { BaseComponent } from '../base.component';
import { BuildingsExportDialogComponent } from './buildings-export-dialog/buildings-export-dialog.component';

export interface Building {
  cdSite: string;
  name_billing_address_1: string;
  name_billing_address_2: string;
  nameSiteFirst: string;
  nameWorkContent: string;
  baInfo: string;
  blInfo: string;
  cdBillingAddress: string;
}

@Component({
  selector: 'app-buildings',
  templateUrl: './buildings.component.html',
  styleUrls: ['./buildings.component.less']
})

export class BuildingsComponent extends BaseComponent implements OnInit, AfterViewInit {
 // 物件一覧テーブルのデータソース
  dataSource = new MatTableDataSource();

 // 物件一覧の全レコードの件数
  dataSourceLength = 0;

  nowLoading = true;

  loadingExport = false;

  keyword = "";

  filterNameBillingAddress = "";

  filterNameSite = "";

  filterAddress = "";

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild('TABLE') table: ElementRef;

  // カラム名 物件一覧
  columnDefs = [
    'nameSiteFirst',
    'nameKanaSite',
    'name_billing_address_1',
    'abbreviation',
    'baInfo',
    'blInfo',
    'mngNote',
    'dstNote',
    'blNote',
    'keyNote'
  ];

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  constructor(private http: HttpClient, private router: Router, private cdr: ChangeDetectorRef, private dialog1: MatDialog, private ngZone: NgZone) {
    super();
  }

  ngOnInit() {
  }

  goTo(comp, param){
    this.ngZone.run(()=>{
    this.router.navigate([comp, param])
    });
  }

  /**
   * ページ読み込み後の初期化メソッド
   */
  ngAfterViewInit() {
    this.filterNameBillingAddress =
      localStorage.getItem('search_buildings_nameBillingAddress') != null ? localStorage.getItem('search_buildings_nameBillingAddress') : "";
    this.filterNameSite =
      localStorage.getItem('search_buildings_nameSite') != null ? localStorage.getItem('search_buildings_nameSite') : "";
    this.dataSource.paginator = this.paginator;
    this.paginator.page.subscribe(() => {
      // 物件一覧表示
      this.getAgreements(this.paginator.pageIndex, this.paginator.pageSize);
      this.getTotalSize(this.keyword);
    });
    this.getTotalSize(this.keyword);
    this.getAgreements(this.paginator.pageIndex, this.paginator.pageSize);
    this.cdr.detectChanges();
  }
  /**
   * セルクリック時のコールバック
   * @param event 選択された行オブジェクト
   */
  cellClicked(event) {
    console.info(event);
    this.router.navigate(['/buildings/' + event.cdSite]);
  }
  cellClicked2(event) {
    console.info(event);
    this.router.navigate(['/customers/' + event.cdBillingAddress]);
  }

  applyFilter(keyword?: string) {
    this.keyword = keyword;
    this.paginator.pageIndex = 0;
    this.getAgreements(this.paginator.pageIndex, this.paginator.pageSize);
    this.getTotalSize(this.keyword);
  }

  /**
   *物件一覧を取得します
   * @param index 開始インデックス
   * @param size  取得サイズ
   */
  getAgreements(index: number, size: number) {
    this.nowLoading = true;
    localStorage.setItem('search_buildings_nameBillingAddress', this.filterNameBillingAddress);
    localStorage.setItem('search_buildings_nameSite', this.filterNameSite);
    localStorage.setItem('search_address', this.filterAddress);

    this.http.get(
      API_BASE_URL + '/api/v1/sites?s=0&e=8000&index=' + index
        + "&size=" + size
        + "&filterNameBillingAddress=" + encodeURIComponent(this.filterNameBillingAddress)
        + "&filterNameSite=" + encodeURIComponent(this.filterNameSite)
        + "&filterAddress=" + encodeURIComponent(this.filterAddress)
      , {headers: this.headers}
      )
    .subscribe(res => {
      this.dataSource = new MatTableDataSource(res as Building[]);
      this.nowLoading = false;
    },
    error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
    });
  }

  /**
   * 全レコードのサイズを取得します
   */
  getTotalSize(keyword: string) {
    this.loadingExport = true;
    this.http.get(
      API_BASE_URL + '/api/v1/sites/allBuilding?filterNameBillingAddress=' + encodeURIComponent(this.filterNameBillingAddress)
        + "&filterNameSite=" + encodeURIComponent(this.filterNameSite)
        + "&filterAddress=" + encodeURIComponent(this.filterAddress)
      , {headers: this.headers}
    ).subscribe(res => {
      let allData = res as [];
      if (allData && allData.length) {
        this.dataSourceLength = allData.length;
      } else {
        this.dataSourceLength = 0;
      }
      this.loadingExport = false;
    },
    error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
      this.nowLoading = false;
    });
  }

  /**
   * エクスポートボタン
   */
  downloadCsv() {
    this.dialog1.open(BuildingsExportDialogComponent, {
      data: {
        data: {
          filterNameSite: this.filterNameSite,
          filterNameBillingAddress: this.filterNameBillingAddress,
          filterAddress: this.filterAddress
        }
      }
    });
  }
}
